import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { checkRosterCsv } from '../Validations/checkRosterCsv';
import Spinner from './Spinner';

export default class CsvChecker extends Component {
  static propTypes = {
    file: PropTypes.instanceOf(Object).isRequired,
    handleCheck: PropTypes.func.isRequired,
    importType: PropTypes.string.isRequired,
    programCodes: PropTypes.instanceOf(Array).isRequired,
    strictPasswordPolicies: PropTypes.instanceOf(Array),
  };

  static defaultProps = {
    strictPasswordPolicies: []
  };

  componentDidMount() {
    this._checkCsv();
  }

  _checkCsv() {
    const reader = new FileReader();
    reader.onload = evt => this._checkRows(evt.target.result);
    reader.readAsText(this.props.file);
  }

  _checkRows(file) {
    const { errors, rowCount } = checkRosterCsv(
      file,
      this.props.importType,
      this.props.programCodes,
      this.props.strictPasswordPolicies
    );

    this.props.handleCheck(errors, rowCount);
  }

  render() {
    return <Spinner />;
  }
}
